module.exports = __webpack_public_path__ + "img/AEONpay.9262a8e3.png";